import type { PayloadAction } from '@reduxjs/toolkit'

export const truncateIdAction = <T extends PayloadAction<Maybe<string>>>(a: T, maxLength = 8) => ({
	...a,
	payload: a.payload?.slice(0, maxLength),
})
